import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";

library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);
  //   const { id } = useParams();

  const id = props.show;
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [data, setData] = useState();
  const [formData, setFormData] = useState({
    country_id: "",
    state_id: "",
    city_id: "",
    name: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    if (
      e?.name === "country_id" ||
      e?.name === "state_id" ||
      e?.name === "city_id"
    ) {
      if (e?.name === "country_id") {
        setFormData({
          ...formData,
          [e.name]: e,
          state_id: "",
          city_id: "", // reset city when country is changed
        });
        getSelectedState(e.value);
      } else if (e?.name === "state_id") {
        setFormData({
          ...formData,
          [e.name]: e,
          city_id: "", // reset city when state is changed
        });
        getSelectedCity(e.value);
      } else if (e?.name === "city_id") {
        setFormData({
          ...formData,
          [e.name]: e,
        });
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  async function getSelectedState(id) {
    const response = await getData(`/allstate/${id}`);

    if (response?.success) {
      setState(response.data);
    }
  }

  async function getSelectedCity(stateId) {
    const response = await getData(`/allcity/${stateId}`);

    if (response?.success) {
      setCity(response.data);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = await Validation.FormValidation({
      classname: ".cityclass",
    });

    const validationErrorsSelect = Validation.SelectValidation({
      classname: ".cityclass",
    });
    if (validationErrors && validationErrorsSelect) {
      try {
        const response = await postData(`/masters/pincode/${id}`, formData);
        if (response?.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/pincode/${id}`);

    setData(response);

    setFormData(response?.data);
    const res = await getData("/allcountry");

    const option = [];
    if (res.success) {
      res?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "country_id",
          label: data.name,
        });
      });
    }
    setCountry(option);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const GetAllCountry = async () => {
    const response = await getData("/allcountry");
    setCountry(response);
  };

  useEffect(() => {
    GetAllCountry();
  }, []);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  const successStyle = {
    color: "green",
    marginLeft: "5px",
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit City
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit} role="form " className="cityclass">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Select Country</Form.Label>

                    <Select
                      name="country_id"
                      className="input-mandatory"
                      onChange={handleChange}
                      value={formData?.country_id}
                      options={country}
                    />

                    <span className="error-message"></span>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label> Select State</Form.Label>

                    <Select
                      name="state_id"
                      className="input-mandatory"
                      onChange={handleChange}
                      value={formData.state_id}
                      options={state?.map((stateOption) => ({
                        value: stateOption.id,
                        name: "state_id",
                        label: stateOption.name,
                      }))}
                    />

                    <span className="error-message"></span>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label> Select City</Form.Label>

                    <Select
                      name="city_id"
                      className="input-mandatory"
                      onChange={handleChange}
                      value={formData.city_id}
                      options={state?.map((cityOption) => ({
                        value: cityOption.id,
                        name: "city_id",
                        label: cityOption.name,
                      }))}
                    />

                    <span className="error-message"></span>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Pincode</Form.Label>

                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData?.name}
                          onChange={handleChange}
                          placeholder="Pincode "
                          id="inputEmail3"
                          className="input-mandatory"
                        />
                      </InputGroup>
                      <span className="error-message"></span>
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>
                  <SaveButton name={"save"} handleSubmit={handleSubmit} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
